<template>
	<small-modal prevent-mask-close @close="close">
		<template #title>Tweede factor</template>
		<template #body>
			<feedback-banner v-if="feedback" :purpose="PurposeOptions.danger" class="feedback-banner-overwrite">{{feedback}}</feedback-banner>
			<p class="auth-header-text">Voer hieronder de verificatiecode in uit uw authenticatie-app om verder te gaan.</p>
			<section class="form authcode-wrapper">
				<auth-code-input :amount-of-inputs="6" @firstTimeCompletion="login" @keydown.enter="login" @authCode="updateAuthcode"/>
			</section>
		</template>
		<template #footer>
			<section class="form">
				<simple-button :size="ButtonSizeOptions.L" class="full-width-button" @click="login">Inloggen</simple-button>
			</section>
		</template>
	</small-modal>
</template>
<script>
import {SimpleButton, SizeOptions as ButtonSizeOptions} from "@datapas/vue-button";
import {FeedbackBanner, PurposeOptions} from "@datapas/vue-feedback";
import {SizeOptions as InputSizeOptions, TextInput} from "@datapas/vue-input";
import {SmallModal} from "@datapas/vue-modal";
import AuthCodeInput from "./AuthCodeInput.vue";

export default {
	name: "TweedeFactorTotpModal",
	emits: [
		'close',
		'login',
		'updateTotp',
	],
	components: {
		AuthCodeInput,
		FeedbackBanner,
		SimpleButton,
		SmallModal,
		TextInput,
	},
	props: {
		totp: {
			type: String,
		},
		feedback: {
			type: String,
		},
	},
	data() {
		return {
			ButtonSizeOptions,
			InputSizeOptions,
			PurposeOptions,
		};
	},
	methods: {
		updateAuthcode(value) {
			this.$emit('updateTotp', value);
		},
		close() {
			this.$emit('close');
		},
		login() {
			this.$emit('login');
		},
	},

};
</script>
<style lang="scss" scoped>
@use "@datapas/scss-framework/src/vars";
@use "@datapas/scss-framework/src/form";
@use "../scss/auth.scss";

.feedback-banner-overwrite {
	margin-bottom: vars.$CONTENT-SPACING;
	white-space: pre-line;
}
</style>